module.exports = __webpack_public_path__ + "static/media/carta_77.a13cbfdb.jpg";